<template>
  <div class="py-1 border-b border-slate-400 flex">
    <div
      v-if="!isEdit"
      class="relative h-10 px-4 flex items-center justify-between flex-grow gap-6 rounded hover:bg-slate-200 overflow-hidden"
      :class="{ 'pointer-events-none': !currentUser.role.includes('admin') }"
      @mouseenter.prevent="isHover = true"
      @mouseleave.prevent="isHover = false"
    >
      <div class="flex max-w-152 truncate">
        <div class="py-1 px-2 flex items-center bg-slate-300 rounded truncate">
          <BlTextBody2
            class="text-slate-800 truncate"
            :title="prospectTag.name"
            :text="prospectTag.name"
          />
        </div>
      </div>
      <div
        class="absolute px-2 flex items-center gap-2 transition-all duration-300 bg-slate-200"
        :class="{
          'right-2 opacity-100': isHover,
          '-right-200 opacity-0': !isHover
        }"
      >
        <BlInputButton
          label="Delete"
          type="outlined-error"
          dense
          @clicked="deleteOpened = true"
        />
        <BlInputButton label="Edit" type="outlined" dense @clicked="openEdit" />
      </div>
    </div>
    <div
      v-else
      id="edit-state"
      class="h-10 px-4 flex items-center justify-between flex-grow gap-6 rounded bg-slate-200"
    >
      <BlInputText :input="nameInput" @changed="inputHandler" />
      <div class="flex items-center gap-2">
        <BlInputButton label="Cancel" type="plain" @clicked="isEdit = false" />
        <BlInputButton
          label="Update"
          type="outlined"
          dense
          :loading="submitLoading"
          :disabled="!nameInput.model || nameInput.model === prospectTag.name"
          @clicked="onUpdate"
        />
      </div>
    </div>
    <BlBackdrop
      v-if="deleteOpened"
      title="Delete tag"
      label="Delete the tag"
      type="error"
      :disabled="submitLoading"
      @backdrop-close="deleteOpened = false"
      @backdrop-action="onRemove"
    >
      <div class="flex flex-wrap gap-1 px-8">
        <BlTextBody2 text="You are about to delete" />
        <BlTextBody2 class="font-bold" :text="prospectTag.name" />
        <BlTextBody2 text="from the center prospect tag." />
        <BlTextBody2 text="Are you sure you want to proceed?" />
        <BlTextBody2 text="This action is irreversible." />
      </div>
    </BlBackdrop>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "ProspectTagItem",
  props: ["prospectTag"],
  components: {
    BlBackdrop,
    BlTextBody2,
    BlInputText,
    BlInputButton
  },
  data() {
    return {
      submitLoading: false,
      isHover: false,
      isEdit: false,
      deleteOpened: false,
      nameInput: {
        placeholder: "Type a name",
        model: ""
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    ...mapActions(["updateProspectTag", "deleteProspectTag"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    openEdit() {
      this.isEdit = true;
      this.nameInput.model = this.prospectTag.name;
    },
    onUpdate() {
      this.submitLoading = true;
      const data = {
        id: this.prospectTag.id,
        prospect_tag: { name: this.nameInput.model }
      };
      this.updateProspectTag(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.isEdit = false;
      });
    },
    onRemove() {
      this.submitLoading = true;
      const data = { id: this.prospectTag.id };
      this.deleteProspectTag(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.deleteOpened = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/tags/ProspectTag.vue